<div class="page-container trade-source-data-container container pt-2">
  <app-breadcrumb [crumbConfig]="crumbConfig"></app-breadcrumb>

  <h1 class="header col-12 mb-3">
    Trade Source Data <small>{{ tradeId }}</small>
  </h1>

  <div class="data-tables-container">
    @if (sourceData && dataTables.length > 0) {
      @for (dataTable of dataTables; track dataTable) {
        <div class="w-50">
          <div class="product-info-container info-card mb-4">
            <div class="card-header">
              <span class="card-title mb-0"> {{ dataTable }} </span>
            </div>
            <table class="details vertical col-12">
              <tbody>
                @for (key of keys(sourceData[dataTable]); track key) {
                  <tr>
                    <th>{{ key }}</th>
                    <td [class.empty-cell]="!sourceData[dataTable][key]">
                      {{ sourceData[dataTable][key] }}
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        </div>
      }
    } @else {
      <div class="no-data-container w-100">
        <h3>No data found</h3>
      </div>
    }
  </div>

  <ngx-loading [show]="loading"></ngx-loading>
</div>
